import React from 'react';
import { calculateInsuranceForecast, getInsuranceForecastList } from 'api/common';
import { TInsuranceForecast } from 'types/common';

let globalData: TInsuranceForecast[] = [];

const useInsuranceForecast = (): [TInsuranceForecast[], boolean, () => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TInsuranceForecast[]>(globalData);
    const [markRefetch, setMarkRefetch] = React.useState(false);
    const fetchData = async () => {
        if (loading.current) {
            return;
        }
        try {
            loading.current = true;
            const result = await getInsuranceForecastList();
            if (!result.error) {
                const data: TInsuranceForecast[] = result?.data?.data?.list || [];
                // if (data.length === 0) {
                //     const res2 = await calculateInsuranceForecast({} as any);
                //     setMarkRefetch(true);
                // }
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    React.useEffect(() => {
        if (markRefetch) {
            fetchData();
        }
    }, [markRefetch]);

    return [items, loading.current, fetchData];
};

export default useInsuranceForecast;
